import { User } from "~/__generated__/graphql"

export const fullName = (user: Pick<User, "firstName" | "lastName">) => {
  return [user.firstName, user.lastName].join(" ")
}
